import { takeLatest } from 'redux-saga/effects';
import { getDetailSaga } from '../../../store/structures';
import {
  markAsFavouriteSaga,
  removeFavouriteSaga,
} from '../../customerCoupons/favourite/saga';

import { types, actions } from './duck';
import { getDetail } from '../api';

export default function* saga() {
  yield takeLatest(types.GET_DETAIL, getDetailSaga(actions, getDetail));
  yield takeLatest(types.MARK_AS_FAVOURITE, markAsFavouriteSaga);
  yield takeLatest(types.REMOVE_FAVOURITE, removeFavouriteSaga);
}
